import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

export const EmbedRoute = () => {
  return (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  );
};
